/**
 *
 * funções gerais de apoio
 *
 * @since 1.0.0
 *
*/

// ordenar alfabeticamente array de objectos pela sua label
const sortObjectsArray = array => {
    return array.sort( ( a, b ) => (
        ( a.label.toLowerCase() > b.label.toLowerCase() ) ? 1 : ( ( b.label.toLowerCase() > a.label.toLowerCase() ) ? -1 : 0 ) ) );
};

// função que converte os valores do atributo primary para booleana.
const stringToBoolean = string => {
    if ( typeof string === 'string' ) {
        switch ( string.toLowerCase().trim() ) {
            case 'true': case '1': return true;
            case 'false': case '0': return false;
            default: return Boolean( string );
        }
    } else {
        switch ( string ) {
            case 1: return true;
            case 0: case null: return false;
            default: return Boolean( string );
        }
    }
};

/**
*
* Transforma uma palavra ou frase em Capitalize apenas na primeira letra da string.
* @param {String} string - palavra/ frase que se pretende transformar
* @return {String} - palavra/ frase tranformada
*
*/
const capitalizeFirstLetter = string => {
    return string.charAt( 0 ).toUpperCase() + string.slice( 1 );
};

export {
    sortObjectsArray,
    stringToBoolean,
    capitalizeFirstLetter
};